<template>
  <div
    v-if="items.length"
    class="pt-8 pt-md-12 pt-lg-16 pb-8 pb-md-12 pb-lg-16 items relative"
  >
    <Loading v-if="loading" />

    <v-container v-else class="relative">
      <Title>Conheça Nossos Especialistas</Title>

      <v-row justify="center">
        <v-col cols="12" md="10" lg="12" class="mt-6 mt-md-8 mt-lg-10">
          <v-row justify="center">
            <div
              class="col-specialty"
              v-for="({ img, title, to }, keySpecialty) in items"
              :key="keySpecialty"
            >
              <v-card
                :to="to"
                height="100%"
                class="
                  px-3 px-sm-5
                  pt-8 pt-md-10 pt-lg-12
                  pb-lg-7 pb-5 pb-md-6
                  item
                "
                tile
              >
                <img
                  v-if="img"
                  :src="files + img"
                  class="d-block mx-auto item-img"
                  height="96px"
                  :alt="title"
                />

                <div
                  class="
                    grey--text
                    text--darken-3 text-h6 text-center
                    font-weight-medium
                    mt-4 mt-md-5
                    item-title
                  "
                >
                  {{ title }}
                </div>
              </v-card>
            </div>
          </v-row>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import { formatToURL } from "../../utils/formatToURL";
import Loading from "../widgets/Loading.vue";
import Title from "../widgets/Title.vue";

const _config = {
  mod: "specialties",
  path: "/equipe",
};

export default {
  data: () => ({
    loading: true,
    path: _config.path,
  }),
  computed: {
    items() {
      return this.$rest(_config.mod).list.map(({ id, img, title }) => ({
        img,
        title,
        to: `${this.path}/${formatToURL(title)}-${id}`,
      }));
    },
  },
  mounted() {
    this.$rest("specialties")
      .get()
      .then(() => (this.loading = false));
  },
  components: {
    Loading,
    Title,
  },
};
</script>

<style lang="scss" scoped>
.items {
  &:before {
    background-color: var(--v-grey-lighten4);
    content: "";
    height: 65%;
    left: 0;
    position: absolute;
    top: 0;
    width: 100%;
  }
  .col-specialty {
    flex: 0 0 20%;
    flex-basis: 0;
    flex-grow: 1;
    max-width: 20%;
    padding: 12px;
    width: 100%;
    @media screen and (max-width: 1264px) {
      flex: 0 0 33.3333334%;
      max-width: 33.3333334%;
    }
    @media screen and (max-width: 600px) {
      flex: 0 0 50%;
      max-width: 50%;
    }
  }
  .item {
    box-shadow: 0px 8px 16px -5px rgba(30, 46, 56, 0.15) !important;
    .item-img {
      max-width: 100%;
      object-fit: contain;
    }
  }
}
</style>
